/** 品题底栏外壳：与 1qnq（L1 + L2 网格）同宽。
 * 宽度走 inline style，避免 Tailwind JIT 扫不到动态任意值导致无 L2 面板缩成内容宽。
 */
import { TTQ_QUESTION_CHAIN_VARIANTS } from './ttqBehaviorCatalog';

/** L1 锁定分类卡宽度（与菜单卡片一致） */
export const TTQ_BOTTOM_PANEL_L1_WIDTH_PX = 220;

/** L2 变式格宽度（仅 1qnq） */
export const TTQ_BOTTOM_PANEL_L2_WIDTH_PX = 148;

/** gap-1.5 → 6px */
const PANEL_GAP_PX = 6;

/** 水平内边距 px-3 × 2 */
const PANEL_PAD_X_PX = 24;

const L2_COLS = Math.ceil(TTQ_QUESTION_CHAIN_VARIANTS.length / 2);

/** 与 1qnq（L1 + L2 网格）同宽，无 L2 的面板靠左占位 */
export const TTQ_BOTTOM_PANEL_INNER_WIDTH_PX = TTQ_BOTTOM_PANEL_L1_WIDTH_PX
  + PANEL_GAP_PX
  + L2_COLS * TTQ_BOTTOM_PANEL_L2_WIDTH_PX
  + Math.max(0, L2_COLS - 1) * PANEL_GAP_PX;

export const TTQ_BOTTOM_PANEL_SHELL_WIDTH_PX = TTQ_BOTTOM_PANEL_INNER_WIDTH_PX + PANEL_PAD_X_PX;

export const TTQ_BOTTOM_PANEL_SHELL_CLASS = [
  'fixed bottom-4 left-1/2 z-40',
  'max-w-[calc(100vw-32px)] -translate-x-1/2',
  'rounded-xl border border-border bg-surface shadow-lg',
].join(' ');

export const TTQ_BOTTOM_PANEL_SHELL_STYLE = {
  width: `min(${TTQ_BOTTOM_PANEL_SHELL_WIDTH_PX}px, calc(100vw - 32px))`,
} as const;
